<template>
    <div class="page_section">
        <div class="container">
            <div class="big_title flex justify-between items-center gap-4">
                <h2 class="section_title mb-3 mb-md-0">{{ title }}</h2>
                <SliderNav @click-prev="carouselPrev" @click-next="carouselNext" />
            </div>
        </div>
        <div class="partners_carousel">
            <div class="container">
                <Carousel
                    :plugins="[Autoplay({
                        delay: 5000,
                        stopOnInteraction: true,
                        stopOnMouseEnter: true,
                    })]"
                    :opts="{
                        loop: true,
                        align: 'start',
                    }"
                    @init-api="setApi">
                    <CarouselContent class="-ml-[30px]">
                        <CarouselItem
                            v-for="(item, i) in items"
                            :key="i"
                            class="pl-[30px] basis-1/2 lg:basis-1/3 xl:basis-1/4">
                            <a :href="item.link" class="partners__item" target="_blank" rel="nofollow">
                                <img :src="item.image" />
                            </a>
                        </CarouselItem>
                    </CarouselContent>
                </Carousel>
            </div>
        </div>
    </div>
</template>

<script setup>
import SliderNav from "~/components/UI/SliderNav.vue";
import Autoplay from "embla-carousel-autoplay";
import {
    Carousel,
    CarouselContent,
    CarouselItem,
} from "~/components/shadcn/ui/carousel";

const props = defineProps({
    items: {
        type: Array,
        required: true
    },
    title: {
        type: String,
        default: 'Партнеры'
    }
});

const carouselApi = ref(null);

function setApi(api) {
    carouselApi.value = api;
}

function carouselPrev() {
    carouselApi.value?.scrollPrev();
}

function carouselNext() {
    carouselApi.value?.scrollNext();
}
</script>

<style>

</style>
